module.exports = __webpack_public_path__ + "img/painel-ferramenta.4dd266e1.jpg";